export const locationList = [{
    NAMETUser: '151',
    NAM_User: '021',
    SEA_User: '053',
    SA_User: '034',
    NA_user: '143',
    Global_User: '005',
    EU_User: '154',
    Africa_User: '015',
    LATAM_User: '029',
    AAR_User: '005',
    DO_Test: '034'
}]

export const locationNameList = [
    {
        NAMETUser: 'Eastern Europe',
        NAM_User: 'Northern America',
        SEA_User: 'Australia',
        SA_User: 'Southern Asia',
        NA_user: 'Asia',
        Global_User: 'South America',
        EU_User: 'Europe',
        Africa_User: 'Africa',
        LATAM_User: 'Americas',
        AAR_User: 'South America',
        DO_Test: 'Southern Asia'
    }
]

